import config from "../config";

/**
 * Backend-served files (e.g. uploaded checklist card images) are stored with a root-relative URL like
 * `/storage/...`, which the browser would resolve against the frontend's own origin. Resolve it
 * against the API origin instead; absolute and blob: URLs pass through unchanged.
 */
export function resolveApiUrl(url: string): string {
  return new URL(url, config.apiBaseUrlV1).href;
}
